import { createContext } from 'react';
import { settings } from 'config';

export const AppContext = createContext(settings);

export const MainContext = createContext(settings);

export const EmailContext = createContext({ emails: [] });

export const ArticleContext = createContext({ articles: [] });

export const ProductContext = createContext({ products: [] });

export const ProductContext2 = createContext({ products: [] });

export const AllProjectContext = createContext({ project: [] });

export const SettingContext = createContext({ settings: [] });

export const RouteContext = createContext({ routs: [] });

export const CourseContext = createContext({ courses: [], primaryCourses: [] });

export const FeedContext = createContext({ feeds: [] });

export const AuthWizardContext = createContext({ user: {} });

//export const CompanyContext = createContext({ user: {} });
export const CompanyContext = createContext({});

export const ContractContext = createContext({});

export const LoanContext = createContext({});

export const WhatsAppContext = createContext({});

export const ProjectContext = createContext({ user: {} });

export const OfferContext = createContext({ user: {} });

export const OrderContext = createContext({ user: {} });

export const InputContext = createContext({ user: {} });

export const PaymentContext = createContext({ user: {} });

export const TelegramContext = createContext({ user: {} });

export const OuputContext = createContext({ user: {} });

export const TerrainsContext = createContext({});

export const ChatContext = createContext();

export const KanbanContext = createContext({
 KanbanColumns: [],
 kanbanTasks: []
});

export default AppContext;
